<template>
  <b-modal
    id="modal-ajuda-cids-ciaps"
    :visible="show"
    @hidden="$emit('update:show', false)"
    @shown="carregar"
    title=""
    size="xl"
    hide-footer
    centered
    scrollable
  >
    <div class="ajuda-cids-ciaps">
      <!-- LOADING -->
      <div v-if="loading" class="text-center my-4">
        <b-spinner label="Carregando"></b-spinner>
        <div class="mt-2 small text-muted">Carregando…</div>
      </div>

      <!-- ERRO -->
      <div v-else-if="error" class="alert alert-danger mb-0">
        {{ error }}
      </div>

      <!-- CONTEÚDO -->
      <div v-else>
        <v-app class="app-tabela">
          <!-- CIAPS -->
          <h4>CIAPS</h4>
          <div class="box mt-0 mb-5">
            <v-card class="tabela">
              <v-card-title>
                <v-text-field
                  v-model="searchCiaps"
                  append-icon="mdi-magnify"
                  label="Buscar código ou descrição"
                  class="input-bottom"
                  single-line
                  hide-details
                />
              </v-card-title>

              <v-data-table
                :headers="headersCiaps"
                :items="indexedItemsCiaps"
                :loading="loading"
                loading-text="Carregando, Por favor espere"
                :search="searchCiaps"
                :footer-props="{
                  itemsPerPageText: '',
                  'items-per-page-options': [10],
                  'disable-items-per-page': true,
                }"
                item-key="index"
                class="elevation-1"
              >
                <template v-slot:[`footer.page-text`]="items">
                  <div class="info-table-item tabela-esus-pec"></div>
                  <span class="paginacao">
                    {{ items.pageStart }} - {{ items.pageStop }} de
                    {{ items.itemsLength }} registros
                  </span>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length"></td>
                </template>

                <template v-slot:progress>
                  <v-progress-linear color="blue" :height="10" indeterminate />
                </template>

                <template v-slot:no-data>
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Selecione outro filtro.</b
                    >
                  </div>
                </template>

                <template v-slot:no-results>
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Selecione outro filtro.</b
                    >
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
          <!-- CIDS -->
          <h4>CIDS</h4>
          <div class="box mt-0 mb-5">
            <v-card class="tabela">
              <v-card-title>
                <v-text-field
                  v-model="searchCids"
                  append-icon="mdi-magnify"
                  label="Buscar código ou descrição"
                  class="input-bottom"
                  single-line
                  hide-details
                />
              </v-card-title>

              <v-data-table
                :headers="headersCids"
                :items="indexedItemsCids"
                :loading="loading"
                loading-text="Carregando, Por favor espere"
                :search="searchCids"
                :footer-props="{
                  itemsPerPageText: '',
                  'items-per-page-options': [10],
                  'disable-items-per-page': true,
                }"
                item-key="index"
                class="elevation-1"
              >
                <template v-slot:[`footer.page-text`]="items">
                  <div class="info-table-item tabela-esus-pec"></div>
                  <span class="paginacao">
                    {{ items.pageStart }} - {{ items.pageStop }} de
                    {{ items.itemsLength }} registros
                  </span>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length"></td>
                </template>

                <template v-slot:progress>
                  <v-progress-linear color="blue" :height="10" indeterminate />
                </template>

                <template v-slot:no-data>
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Selecione outro filtro.</b
                    >
                  </div>
                </template>

                <template v-slot:no-results>
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Selecione outro filtro.</b
                    >
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-app>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalAjudaCidsCiaps',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    grupoFiltro: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      error: null,
      itemsCiaps: [],
      searchCiaps: '',
      headersCiaps: [
        {
          text: 'Grupo',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'id_grupo',
        },
        { text: 'Código', align: 'start', filterable: true, value: 'nu_ciap' },
        {
          text: 'Descrição',
          align: 'start',
          filterable: true,
          value: 'no_ciap',
        },
      ],
      itemsCids: [],
      searchCids: '',
      headersCids: [
        {
          text: 'Grupo',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'id_grupo',
        },
        { text: 'Código', align: 'start', filterable: true, value: 'nu_cid' },
        {
          text: 'Descrição',
          align: 'start',
          filterable: true,
          value: 'no_cid',
        },
      ],
    }
  },
  computed: {
    indexedItemsCiaps() {
      return this.itemsCiaps.map((it, idx) => ({
        index: idx,
        ...it,
      }))
    },
    indexedItemsCids() {
      return this.itemsCids.map((it, idx) => ({
        index: idx,
        ...it,
      }))
    },
  },
  methods: {
    grupoPassaNoFiltro(idGrupo) {
      // Se o array vier vazio - aceita todos os grupos
      if (this.grupoFiltro.length === 0) return true

      // Se tiver valores - aceita apenas os que estiverem no array
      return this.grupoFiltro.includes(idGrupo)
    },

    async carregar() {
      this.loading = true
      this.error = null
      this.itemsCids = []
      this.itemsCiaps = []

      try {
        const response = await this.$api.get(
          `/app/utils/cids-ciaps/${this.$store.state.cod_ibge}`
        )

        // CIAPS
        const gruposCiaps = response.data.ciaps || []
        const listaCiaps = []
        gruposCiaps.forEach((grupo) => {
          if (!this.grupoPassaNoFiltro(grupo.id_grupo)) return
          if (!grupo.ciaps) return
          let ciapsArray = []
          try {
            ciapsArray = JSON.parse(grupo.ciaps)
          } catch (e) {
            console.error('Erro ao fazer parse de ciaps:', e, grupo.ciaps)
            return
          }
          ciapsArray.forEach((ciap) => {
            listaCiaps.push({
              id_grupo: grupo.id_grupo,
              nu_ciap: ciap.nu_ciap,
              no_ciap: ciap.no_ciap,
            })
          })
        })
        this.itemsCiaps = listaCiaps

        // CIDS
        const gruposCids = response.data.cids || []
        const listaCids = []
        gruposCids.forEach((grupo) => {
          if (!this.grupoPassaNoFiltro(grupo.id_grupo)) return
          if (!grupo.cids) return
          let cidsArray = []
          try {
            cidsArray = JSON.parse(grupo.cids)
          } catch (e) {
            console.error('Erro ao fazer parse de cids:', e, grupo.cids)
            return
          }
          cidsArray.forEach((cid) => {
            listaCids.push({
              id_grupo: grupo.id_grupo,
              nu_cid: cid.nu_cid,
              no_cid: cid.no_cid,
            })
          })
        })
        this.itemsCids = listaCids
      } catch (e) {
        console.error(e)
        this.error = 'Não foi possível carregar os dados.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.ajuda-cids-ciaps code {
  font-size: 0.8rem;
}
</style>
